import { Scope } from '@talpor/react-context-manager';

import api, { request } from 'api';

import { IStore } from '../index';

export interface IResourcesActions extends Scope<IStore> {
  getResources: (state: IStore) => (query?: string) => Promise<IStore>;
  getSkills: (state: IStore) => () => Promise<IStore>;
}

export const resourcesActions: IResourcesActions = {
  getResources: (state: IStore) => async (query?: string) => {
    const resources = await request.get(query ? api.resources(query) : api.resources());

    if (resources.error) {
      return {
        ...state,
        misc: {
          loading: false,
          notification: {
            status: true,
            message: resources.error.body.message.message,
            type: 'error',
          },
        },
      };
    }

    const featuredResources = resources.filter((item: any) => item.featured);

    return {
      ...state,
      resources: {
        ...state.resources,
        resources,
        featuredResources,
      },
    };
  },
  getSkills: (state: IStore) => async () => {
    const skills = await request.get(api.skills);

    if (skills.error) {
      return {
        ...state,
        misc: {
          loading: false,
          notification: {
            status: true,
            message: skills.error.body.message.message,
            type: 'error',
          },
        },
      };
    }

    return {
      ...state,
      resources: {
        ...state.resources,
        skills,
      },
    };
  },
};
